import React from 'react';
import Image from 'next/image';

const ValuePropositionAiSecurityGovernance = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
            <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                <source src="media/aiml-section.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-8 grid">
                        <h2 className="text-white mb-2.5">
                            Value Proposition
                        </h2>
                        <p className='dark:text-[#D7DEE5] mb-2.5'>Secure AI systems with robust governance - protect data, ensure compliance, build trust.</p>
                        <p className='dark:text-[#D7DEE5] mb-0'>
                            Protect your data, ensure compliance with global regulations, and build trusted AI systems with our comprehensive AI Security & Governance solutions. We help organizations implement strong oversight to mitigate risks, maintain accountability, and foster confidence in AI technologies. We bridge the gap between innovation and responsible AI deployment.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Unregulated AI use leading to compliance risks, data breaches via AI systems, absence of AI audit trails, regulatory sanctions from unmanaged AI, model biases and ethical issues, shadow AI circumventing security measures, and inability to prove AI accountability.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                           width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Establishing AI security frameworks and threat defenses, governance policies and access management, continuous model monitoring and bias detection, automating compliance for GDPR, HIPAA, SOC 2, and AI Act, ensuring data privacy and encryption, maintaining audit trails and explainability, implementing responsible AI practices.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Outcomes</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            90% drop in AI security incidents, 100% audit compliance, accelerating regulatory reporting by 75%, zero data breaches from AI systems, and a 60% increase in model transparency.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValuePropositionAiSecurityGovernance;
